export default {
    new_account_required_message: 'Aufgrund der Einführung eines neuen Buchungssystems bitten wir Sie, ein neues Konto zu erstellen.<br/>Ein Konto, das vor dem 07.04.2025 erstellt wurde, wird in der neuen Version des Systems nicht funktionieren.',
    new_account_required_message_2: 'HINWEIS: Wenn Sie möchten, können Sie auch eine Fahrt buchen, ohne ein Konto zu erstellen.',
    new_account_required_confirmation: 'Ich verstehe, nicht erneut anzeigen',
    general_error: 'Ein Fehler ist aufgetreten, bitte versuchen Sie es später erneut',
    followme_title: 'Follow me!',
    lang_pl: 'PL',
    lang_en: 'EN',
    lang_de: 'DE',
    date: 'Datum',
    loading: 'Laden',
    send: 'Absenden',
    baggage_hand: 'Handgepäck bis 5 kg',
    baggage_register: 'Aufgegebenes Gepäck bis 25 kg',
    book_and_payment: 'Buchen und bezahlen',
    book: 'Buchen',
    delete: 'Eingabe löschen',
    back: 'Zurück',
    next: 'Weiter',
    yes: 'Ja',
    no: 'Nein',
    select: 'Auswählen',
    net: 'zzgl. MwSt.',
    gross: 'inkl. MwSt.',
    piece: 'Stk.',
    vehicle: 'Fahrzeug',
    cancel: 'Stornieren',
    ok: 'Ok',
    email_example: 'Z.B. email@gmail.com',
    departure: 'Hinfahrt',
    return: 'Rückfahrt',
    departure_date: 'Hinfahrt Datum',
    departure_time: 'Hinfahrt Zeit',
    return_date: 'Rückfahrt Datum',
    return_time: 'Rückfahrt Zeit',
    date_pick: 'Datum auswählen',
    from: 'Von',
    to: 'Nach',
    passenger: 'Reisende',
    passengers: 'Reisenden',
    passengers_amount: 'Anzahl der Passagiere',
    adults: 'Erwachsenen',
    kids: 'Kinder',
    child_age_3: 'Kinder bis 3 Jahre',
    purchaser_details: 'Kontaktdaten',
    invoice: 'Rechnung',
    payment_method: 'Zahlungsmethode',
    order_error: 'Bestellungsfehler',
    home_title: 'Follow me! Online Buchung',

    first_name: 'Vorname',
    last_name: 'Nachname',
    email: 'E-Mail-Adresse',
    phone_number: 'Telefonnummer',
    street: 'Straße',
    building_number: 'Hausnummer',
    apartment_number: 'Wohnungsnummer',
    airport: 'Flughafen',
    zip: 'Postleitzahl',
    flight_number: 'Flugnummer',
    comment: 'Bemerkungen',
    vat_number: 'Steuernummer',
    address: 'Adresse',
    post_code: 'Postleitzahl',
    city: 'Stadt',
    country: 'Land',
    company_name: 'Firmenname',
    age: 'Alter',

    price: 'Preis',
    total: 'Insgesamt',

    admin_panel: 'Admin Panel',

    no_transfers_found: 'Keine Fahrten gefunden',

    no_transfers_found_ask_by_email: 'Sind an den von Ihnen gewählten Daten keine Transfers verfügbar, wenden Sie sich per E-Mail an unseren Kundenservice <a href="mailto:{email}">{email}</a>.',

    at_ber_outdated_travel: 'Ab dem 28. April 2022 werden Fahrten zum Flughafen BER (Berlin Brandenburg) und vom Flughafen BER (Berlin Brandenburg) mit dem Flixbus (Busse und Fahrer von Follow me!) realisiert. Sie können eine Reservierung unter <a href="https://flixbus.pl/" target="_blank">flixbus.pl</a> vornehmen.',

    at_ber_outdated_travel_2: 'Falls Sie keine passende Verbindung finden kann, testen Sie unseren neuen Service: BERBUS - Ridesharing per Haustürtransfer zum Flughafen Berlin.',

    field_is_required: '{field} Pflichfeld',

    datetime_has_to_be_in_the_future: 'Feld {field} muss zukünftig sein',
    datetime_has_to_be_in_2_days_from_now: 'Zu kurze Zeit bis zur Abfahrt – Buchung ist mindestens 48 Stunden vor Beginn der Fahrt möglich',
    time_has_to_be_later_than: 'Feld {field} muss später als {field_parent} sein',
    phone_has_to_start_with_plus: 'Telefonnummer muss die Vorwahl mit dem Plus-Zeichen haben',

    data_updated_success: 'Daten wurden erflogreich aktualisiert',

    maintenance_long_wait_info: 'Auftragszeit hat sich verlängert?<br />Gehen Sie zum Ticketkauf auf <a href="https://www.interglobus.pl/Default.aspx?language=de">interglobus.pl</a>.',

    user_data: {
        header: 'Meine Daten',
        name: 'Vor- und Nachnahme',
        phone: 'Telefonnummer',
        submit: 'Speichern',
    },

    auth: {
        session_expired: 'Sitzung abgelaufen, bitte melden Sie sich erneut an, um fortzufahren.',
        activate_account_here: 'Aktivieren Sie Ihr Konto hier:',
        activate_account_here_link: 'Aktivierung',
        required_fields_info: 'Pflichtfelder',
        confirm_registration: 'Bestätigen Sie die Kontoanmeldung',
        activation_code: 'Aktivierungscode',
        confirm: 'Bestätigen',
        confirm_resend: 'Code nicht erhalten?',
        confirm_resend_submit: 'Code erneut senden',
        confirm_success: 'Das Konto wurde aktiviert, Sie können sich jetzt anmelden.',
        confirm_resend_back: 'Zurück',
        confirm_resend_success: 'Code erneut gesendet, überprüfen Sie Ihren Posteingang.',
        login_failed: 'Ungültige E-Mail-Adresse oder Passwort.',
        login_success: 'Erfolgreich eingeloggt',
        register_success: 'Erfolgreich registriert. Bestätigen Sie die Registrierung, indem Sie auf den Link in der an die angegebene E-Mail-Adresse gesendeten Nachricht klicken.',
        reset_password_success: 'Ein Link zum Zurücksetzen des Passworts wurde an die angegebene E-Mail-Adresse gesendet.',
        first_name: 'Vorname',
        last_name: 'Nachname',
        login_header: 'Einloggen',
        email: 'E-Mail-Adresse',
        email_address: 'E-Mail-Adresse',
        password: 'Passwort',
        confirm_password: 'Passwort bestätigen',
        forgot_password: 'Haben Sie Ihr Passwort vergessen?',
        password_match_warning: 'Passwörter müssen übereinstimmen',
        remember_me: 'Speichern',
        submit: 'Einloggen',
        login: 'Einloggen',
        logout: 'Ausloggen',
        register: 'Registrieren',
        reset_password: {
            header: 'Passwort zurücksetzen',
            send_link_submit: 'Link senden',
            submit: 'Ändern',
            password_changed: 'Passwort erfolgreich geändert',
        },
        username: 'Benutzername',
        personal_register: 'Personenkonto',
        business_register: 'Geschäftskonto',
        activation_warning: 'Das Konto wird nach der Admin-Bestätigung aktiviert',
        profile: {
            invoice_info: 'Rechnungsdaten',
            company_name: 'Firmenname',
            address: 'Adresse',
            tax_number: 'Steuernummer',
            phone: 'Telefonnummer',
            post_code: 'Postleitzahl',
            city: 'Stadt',
            country: 'Land',
        },
        countries: {
            POLAND: 'Polen',
            AUSTRIA: 'Österreich',
            BELGIUM: 'Belgien',
            BULGARIA: 'Bulgarien',
            CROATIA: 'Kroatien',
            REPUBLIC_OF_CYPRUS: 'Republik Zypern',
            CZECH_REPUBLIC: 'Tschechien',
            DENMARK: 'Dänemark',
            ESTONIA: 'Estland',
            FINLAND: 'Finnland',
            FRANCE: 'Frankreich',
            GERMANY: 'Deutschland',
            GREECE: 'Griechenland',
            HUNGARY: 'Ungarn',
            IRELAND: 'Irland',
            ITALY: 'Italien',
            LATVIA: 'Lettland',
            LITHUANIA: 'Litauen',
            LUXEMBOURG: 'Luxemburg',
            MALTA: 'Malta',
            NETHERLANDS: 'Niederlande',
            PORTUGAL: 'Portugal',
            ROMANIA: 'Rumänien',
            SLOVAKIA: 'Slowakei',
            SLOVENIA: 'Slowenien',
            SPAIN: 'Spanien',
            SWEDEN: 'Schweden',
        },
    },

    offer_types: {
        airport_transfers: 'Szczecin - Goleniów ✈️ - Szczecin',
        airport_transfers_card_title: 'Szczecin - Goleniów',
        business_taxi: 'Business Taxi',
        family_airport_taxi: 'Smart Taxi',
        coaches: 'Busvermietung',
        business_travel_management: 'Business Travel Management',
        bus_rental: 'Busvermietung (ohne Fahrer)',
        tours: 'Reisen',
        berbus: 'BERBUS Szczecin - Berlin ✈️ - Szczecin',
        berbus_card_title: 'Szczecin - Berlin',
    },

    components: {
        phone_input: {
            format_hint: 'Format: +48500500500',
        },

        taxi_search_form: {
            from: 'Von',
            to: 'Nach',
            search_no_results: 'Wählen Sie einen Flughafen aus oder geben Sie eine Adresse ein, beginnend mit dem Straßennamen.',
            search_no_results2: 'Wenn Sie Probleme haben, kontaktieren Sie uns: <a href="mailto:{email}">{email}</a>.',
            date_pick: 'Datum auswählen',
            submit: 'Suchen',
            add_time: 'Uhrzeit angeben',

            departure_date: 'Hinfahrt Datum',
            departure_time: 'Hinfahrt Zeit',
        },

        passengers: {
            quantity: 'niemand | 1 Personen  | {count} Personen | {count} Personen',
            quantity_adults: 'niemand | 1 Erwachsene | {count} Erwachsene | {count} Erwachsenen',
            quantity_children: 'ohne Kinder | 1 Kind | {count} Kinder',
            quantity_label: 'Personenanzahl',
            quantity_label_adults: 'Anzahl Erwachsene',
            quantity_label_children: 'Anzahl Kinder',
            quantity_label_children_max_3: 'Anzahl Kinder im Alter von 0-2',
        },
        coach_search_form: {
            from: 'Hinfahrt von',
            to: 'Ankunft in',
            search_no_results: 'Ort angeben, falls kein Ort gefunden wurde, kontaktieren Sie uns.',
            date_pick: 'Datum angeben',
            time_pick: 'Zeit angeben',
            departure_date: 'Hinfahrt Datum',
            departure_time: 'Hinfahrt Zeit',
            return_date: 'Rückfahrt Datum',
            return_time: 'Rückfahrt Zeit',
            submit: 'Weiter',
            word_from: 'aus',
            progress_bar: {
                step1: 'Standardinformationen',
                step2: 'Fahrt',
                step3: 'Zusatzoptionen',
                step4: 'Kontaktformular',
                step5: 'Zusammenfassung',
            },
        },
    },

    taxi: {
        return_datetime: 'Rückfahrt Datum und Zeit',
        return_date: 'Rückfahrt Datum',
        return_time: 'Rückfahrt Zeit',
        provide_flight_time: 'Hinflug Zeit',
        provide_flight_arrival_time: 'Ankunft Zeit',

        validation: {
            'return_date_required': 'Pflichtfeld - Rückflug Datum',
            'return_time_required': 'Pflichtfeld - Rückflug Zeit',
            'at_least_one_passenger_required': 'Mindestens einen Fahrgast angeben',
            'return_time_after_departure_time': 'Datum und Zeit der Rückfahrt muss später sein',
        },

        components: {
            cart: {
                header: 'Deine Reise',

                no_travel: 'Fahrzeug auswählen.',
                departure: 'Hinfahrt',
                return: 'Rückfahrt',

                base_price: 'Stadardpreis',
                discount_value: 'Rabatt',
                user_discount_value: 'Mitgliederrabatt',
            },

            progress: {
                search: 'Suchen',
                journey_select: 'Fahrt suchen',
                passengers_data: 'Fahrgäste Daten',
                addresses: 'Adressen',
                additional_options: 'Zusatzoptionen',
                summary_and_payment: 'Zusammenfassung und Zahlung',
            },
        },

        pages: {
            vehicles: {
                no_transfers_found: 'Keine Verbindungen gefunden',
                short_time: 'Bis zu Ihrer Fahrt sind es weniger als 48 Stunden.  <br />  \n' +
                    'Bei einer Reservierung während unserer Bürozeiten (Mo-Fr 8:00-18:00 Uhr, Sa-So 10:00-18:00 Uhr) prüfen wir die Verfügbarkeit des Fahrzeugs und bestätigen Ihre Reservierung innerhalb weniger Stunden. <br /> \n' +
                    'Bei einer Reservierung außerhalb der Bürozeiten wird Ihre Reservierung am darauffolgenden Tag bestätigt.',

                short_time_st: 'Bis zu Ihrer Fahrt sind es weniger als 36 Stunden. <br />  \n' +
                    'Bei einer Reservierung während unserer Bürozeiten (Mo-Fr 8:00-18:00 Uhr, Sa-So 10:00-18:00 Uhr) prüfen wir die Verfügbarkeit des Fahrzeugs und bestätigen Ihre Reservierung innerhalb weniger Stunden. <br /> \n' +
                    'Bei einer Reservierung außerhalb der Bürozeiten wird Ihre Reservierung am darauffolgenden Tag bestätigt.',

                short_time_bt: 'Bis zu Ihrer Fahrt sind es weniger als 36 Stunden. <br />  \n' +
                    'Bei einer Reservierung während unserer Bürozeiten (Mo-Fr 8:00-18:00 Uhr, Sa-So 10:00-18:00 Uhr) prüfen wir die Verfügbarkeit des Fahrzeugs und bestätigen Ihre Reservierung innerhalb weniger Stunden. <br /> \n' +
                    'Bei einer Reservierung außerhalb der Bürozeiten wird Ihre Reservierung am darauffolgenden Tag bestätigt.',

                eco_vehicle_confirmation: '<p>Sie haben ECO ausgewählt {offerType}, zu Ihrer Fahrt wird ein Fahrgast angepasst {offerType}.</p>' +
                    '<p>Wichtig!<br />Falls keine Anpassung mit einem anderen Fahrgast zur Verfügung steht {offerType} können Sie eine Fahrt zum regulären Preis (gegen Zuschlag) bekommen oder ohne Kosten die Fahrt stornieren.</p>',
                price_includes: 'Im Preis',
                prefer_info: 'Bitte beachten Sie, dass wir den Service mit einem anderen Auto derselben Klasse durchführen, wenn die ausgewählte Automarke nicht verfügbar ist.',
            },
            addresses: {
                header: 'Adressen',

                pickup_addresses: 'Abholadresse',
                destination_addresses: 'Zieladresse',

                return_travel: 'Rückfahrt',

                return_pickup_addresses: 'Rückfahrt: Abholadresse',
                return_destination_addresses: 'Rückfahrt: Zieladresse',

                address_add: 'Zusätzliche Adresse angeben',
                address_remove_confirm: 'Möchten Sie die Adresse entfernen?',
                book_return: 'Ich möchte die Rückfahrt buchen',

                submit: 'Weiter zu Zusatzoptionen',

                return_not_possible: 'Unsere Preisliste enthält keine passende Fahrt zu Ihrer Rückfahrt, kontaktieren Sie uns bitte, falls Sie die Rückfahrt brauchen: <a href="mailto:{email}">{email}</a>',

                pickup_address_info_title: 'Fügen Sie neue Adresse hinzu',
                pickup_address_info_desc: '<p>Wenn Sie einen dritten Abholort hinzufügen möchten, geben Sie diesen im Kommentar ein. Der Preis den zusätzlichen Abholort beträgt 9,00 zł brutto.</p><p>Das ist keine standardmäßige Option, deshalb werden die genannten Kosten nicht in der Zahlung für diese Bestellung enthalten. Der ausstehende Betrag soll separat bezahlt werden, anhand der Anweisung, der von Follow Me! per E-Mail zukommen lassen wird.</p>',
            },

            passengers: {
                'login_in_to_speed_up_process': 'Haben Sie ein Benutzerkonto? Loggen Sie sich ein, um die Reservierung zu beschleunigen.',
                'passengers_data': 'Fahrgäste Daten',
                'go_to_addresses': 'Weiter zu Adressen',
                'add_next_passenger_data': 'Weiteren Fahrgast angeben',
            },

            options: {
                header: 'Zusatzoptionen',

                comments: 'Bemerkung zu Zusatzoptionen (optional)',

                submit: 'Weiter zur Zusammenfassung',
            },

            summary: {
                header: 'Zusammenfassung und Zahlung',

                email_tooltip: 'An die angegebene E-Mail-Adresse wird die Reservierungsbestätigung und die Fahrkarten verschickt.',
                phone_number_tooltip: 'Telefonnummer nur für Notfälle',

                is_invoice: 'Ich brauche eine Rechnung',

                invoice: {
                    name: 'Name',
                },

                tos: 'Hiermit akzeptiere ich  {general} und {privacy}.',
                tos_general: 'die AGB',
                tos_privacy: 'die Datenshutzerklärung',

                consents_text: 'Die Reservierung gilt als erfolgt, sobald die Zahlung erfolgt ist und die Bestätigung per E-Mail eingegangen ist. Sollte keine Bestätigung vorliegen, kontaktieren Sie uns bitte.',

                submit: 'Jetzt bezahlen {amount}',
                submit_no_payment: 'Reservierung abschicken',

                creating_order: 'Reservierung bearbeiten',
                creating_order_redirect: 'Sie werden gleich an die Seite mit Zahlungen weitergeleitet',

                discount_codes: {
                    header: 'Gutscheine',
                    submit: 'Einlösen',
                },

                short_time_payment: 'Unser Mitarbeiter wird die Bestätigung mit dem Link für die Zahlung verschicken.',
                delayed_payment: 'Kauf auf Rechnung möglich',
                create_user_account: 'Benutzerkonto mit folgenden Daten eröffnen',

                payment_polcard: '[First Data Polcard] Zahlung mit Kreditkarte / Überweisung',
                payment_ecard: 'Zahlung mit Kreditkarte / Überweisung / BLIK',
                payment_ecard_optional_info: 'Die Zahlungsmethode eCard wird Ende September 2024 deaktiviert',

                use_first_passenger_data: 'Die Daten vom ersten Fahrgast verwenden',
            },

            confirmation: {
                header: 'Die Reservierung #{orderNumber}',
                bt: {
                    paid: '<p>Die Reservierung Nr. {orderNumber} wird bearbeitet.</p>' +
                        '<p>Ihre Reservierung wurde bezahlt, die Details wurden an die angegebene E-Mail-Adresse verschickt.</p>' +
                        '<p>WICHTIG: wenn Sie zum Flughafen fahren, vergewissern Sie sich, ob Sie Ihre Reise mit der Zeitreserve geplant haben. Vergessen Sie nicht, dass die sichere Fahrt zum Flughafen mindestens 2 Stunden vor dem Abflug dauert.</p>' +
                        '<p>Wir sehen uns an Bord von Follow me!</p>',
                    paid_eco: '<p>Die Reservierung Nr. {orderNumber} wird bearbeitet.</p>' +
                        '<p>Sie haben ECO Business Taxi ausgewählt, zu Ihrer Fahrt wird ein Fahrgast angepasst, damit Sie den günstigsten Preis für Business Taxi bekommen.</p>' +
                        '<p>Falls keine Anpassung mit einem anderen Fahrgast zur Verfügung steht, können Sie eine Fahrt zum regulären Preis für Business Taxi (gegen Zuschlag) bekommen oder ohne Kosten die Fahrt stornieren. Alle Informationen bekommen Sie von uns in der weiteren E-Mail.</p>' +
                        '<p>Wenn Sie keine E-Mail erhalten haben, prüfen Sie Spam-Ordner oder wenden Sie sich mit Ihrer Reservierungsnummer an unseren Kundenservice.</p>',
                    short_time: '<p>Die Reservierung Nr.  {orderNumber} wird bearbeitet.</p>' +
                        '<p>Zu deiner Fahrt ist weniger als 48 Stunden, wir brauchen die Verfügbarkeit von Fahrzeugen zu prüfen.</p>' +
                        '<p>Wir werden bis maximal 2 Stunden Ihre Reservierung bestätigen. Die Benachrichtigung und weitere Details bekommen Sie an die angegebene E-Mail-Adresse.</p>' +
                        '<p>Wenn Sie keine E-Mail erhalten haben, prüfen Sie Spam-Ordner oder wenden Sie sich mit Ihrer Reservierungsnummer an unseren Kundenservice.</p>',
                    deferred: '<p>Die Reservierung Nr. {orderNumber} wird bearbeitet.</p>' +
                        '<p>Die Details wurden an die angegebene E-Mail-Adresse verschickt.</p>' +
                        '<p>WICHTIG: wenn Sie zum Flughafen fahren, vergewissern Sie sich, ob Sie Ihre Reise mit der Zeitreserve geplant haben. Vergessen Sie nicht, dass die sichere Fahrt zum Flughafen mindestens 2 Stunden vor dem Abflug dauert.</p>' +
                        '<p>Wir sehen uns an Bord von Follow me!</p>',
                },
                fat: {
                    paid: '<p>Die Reservierung Nr.  {orderNumber} wird bearbeitet.</p>' +
                        '<p>Ihre Reservierung wurde bezahlt, die Details wurden an die angegebene E-Mail-Adresse verschickt.</p>' +
                        '<p>WICHTIG: wenn Sie zum Flughafen fahren, vergewissern Sie sich, ob Sie Ihre Reise mit der Zeitreserve geplant haben. Vergessen Sie nicht, dass die sichere Fahrt zum Flughafen mindestens 2 Stunden vor dem Abflug dauert.</p>' +
                        '<p>Wir sehen uns an Bord von Follow me!</p>',
                    paid_eco: '<p>Die Reservierung Nr. {orderNumber} wird bearbeitet.</p>' +
                        '<p>Sie haben ECO Smart Taxi ausgewählt, zu Ihrer Fahrt wird ein Fahrgast angepasst, damit Sie den günstigsten Preis für Smart Taxi bekommen.</p>' +
                        '<p>Wichtig! Falls keine Anpassung mit einem anderen Fahrgast zur Verfügung steht, können Sie eine Fahrt zum regulären Preis (gegen Zuschlag) bekommen oder ohne Kosten die Fahrt stornieren. Alle Details bekommen Sie von uns in der weiteren E-Mail.</p>' +
                        '<p>Wenn Sie keine E-Mail erhalten haben, prüfen Sie Spam-Ordner oder wenden Sie sich mit Ihrer Reservierungsnummer an unseren Kundenservice. </p>',
                    short_time: '<p>Die Reservierung Nr. {orderNumber} wird bearbeitet.</p>' +
                        '<p>Zu deiner Fahrt ist weniger als 48 Stunden, wir brauchen die Verfügbarkeit von Fahrzeugen zu prüfen.</p>' +
                        '<p>Wir werden bis maximal 2 Stunden Ihre Reservierung bestätigen. Die Benachrichtigung und weitere Details bekommen Sie an die angegebene E-Mail-Adresse.</p>' +
                        '<p>Wenn Sie keine E-Mail erhalten haben, prüfen Sie Spam-Ordner oder wenden Sie sich mit Ihrer Reservierungsnummer an unseren Kundenservice.</p>',
                    deferred: '<p>Die Reservierung Nr. {orderNumber} wird bearbeitet.</p>' +
                        '<p>Die Details wurden an die angegebene E-Mail-Adresse verschickt.</p>' +
                        '<p>WICHTIG: wenn Sie zum Flughafen fahren, vergewissern Sie sich, ob Sie Ihre Reise mit der Zeitreserve geplant haben. Vergessen Sie nicht, dass die sichere Fahrt zum Flughafen mindestens 2 Stunden vor dem Abflug dauert.</p>' +
                        '<p>Wir sehen uns an Bord von Follow me!</p>',
                },
                berbus: {
                    paid: `<p>Die Reservierung Nr. <em>{orderNumber}</em> wird bearbeitet.</p>
                        <p>Ihre Reservierung wurde bezahlt, die Details wurden an die angegebene E-Mail-Adresse verschickt. Beim Ridesharing BERBUS, die angegebene Abfahrtszeit ist unverbindlich und wird noch von unserem Mitarbeiter geprüft. Die endgültige Abfahrtszeit von der angegebenen Adresse wird maximal 24 Stunden vor der Abreise bestätigt.</p>
                        <p>WICHTIG: wenn Sie zum Flughafen fahren, vergewissern Sie sich, ob Sie Ihre Reise mit der Zeitreserve geplant haben. Vergessen Sie nicht, dass die sichere Fahrt zum Flughafen mindestens 2 Stunden vor dem Abflug dauert.</p>
                        <p>Wir sehen uns an Bord von Follow me!</p>`,
                    paid_eco: `<p>Die Reservierung Nr. <em>{orderNumber}</em> wird bearbeitet.</p>
                        <p>Ihre Reservierung wurde bezahlt, die Details wurden an die angegebene E-Mail-Adresse verschickt. Beim Ridesharing BERBUS, die angegebene Abfahrtszeit ist unverbindlich und wird noch von unserem Mitarbeiter geprüft. Die endgültige Abfahrtszeit von der angegebenen Adresse wird maximal 24 Stunden vor der Abreise bestätigt.</p>
                        <p>WICHTIG: wenn Sie zum Flughafen fahren, vergewissern Sie sich, ob Sie Ihre Reise mit der Zeitreserve geplant haben. Vergessen Sie nicht, dass die sichere Fahrt zum Flughafen mindestens 2 Stunden vor dem Abflug dauert.</p>
                        <p>Wir sehen uns an Bord von Follow me!</p>`,
                    short_time: `<p>Die Reservierung Nr. <em>{orderNumber}</em>  wird bearbeitet.</p>
                        <p>Da Ihre Fahrt innerhalb von 48 Stunden erfolgt, wird die Verfügbarkeit in dem Termin bestätigt.</p>
                        <p>Wir werden bis maximal 2 Stunden Ihre Reservierung bestätigen. Die Benachrichtigung und weitere Details bekommen Sie an die angegebene E-Mail-Adresse. </p>
                        <p>Wenn Sie keine E-Mail erhalten haben, prüfen Sie Spam-Ordner oder wenden Sie sich mit Ihrer Reservierungsnummer an unseren Kundenservice.</p>`,
                    deferred: `<p>Die Reservierung Nr. <em>{orderNumber}</em> wird bearbeitet.</p>
                        <p>Die Details wurden an die angegebene E-Mail-Adresse verschickt.</p>
                        <p>WICHTIG: wenn Sie zum Flughafen fahren, vergewissern Sie sich, ob Sie Ihre Reise mit der Zeitreserve geplant haben. Vergessen Sie nicht, dass die sichere Fahrt zum Flughafen mindestens 2 Stunden vor dem Abflug dauert.</p>
                        <p>Wir sehen uns an Bord von Follow me!</p>`,
                },
            },

            payment_error: {
                header: 'Zahlung abgelehnt.',
                details: 'Die Zahlung wurde abgelehnt.',
            },
        },
    },

    airport_transfers: {
        components: {
            search_form: {
                from: 'Von',
                to: 'Nach',
                search_no_results: 'Ort angeben, falls kein Ort gefunden wurde, kontaktieren Sie uns: <a href="mailto:{email}">{email}</a>',
                date_pick: 'Datum auswählen',
                submit: 'Suchen',
                one_way: 'One-Way-Fahrt',
            },
            progress_header: {
                step1: 'Allgemeine Informationen',
                step2: 'Abfahrten',
                step3: 'Rückfahrten',
                step4: 'Fahrgäste Daten',
                step5: 'Zusatzoptionen',
                step6: 'Zusammenfassung',
            },
        },
        pages: {
            lowest_price: 'Bester Tagespreis',
            all_transfers: 'Alle Fahrten',
            select: 'Auswählen',
            cart: {
                your_travel: 'Deine Reise',
                empty_message: 'Fahrt auswählen und zu Ihrer Reise hinzufügen',
            },
            pick_departure_stop: 'Haltestelle auswählen',
            pick_arrival_stop: 'Haltestelle auswählen',
            change_stop: 'Haltestelle ändern',
            destination_airport: 'Zielflughafen',

            confirmation: {
                header: 'Die Bestellung wird bearbeitet',
                details: 'Die Details bekommen Sie an Ihre E-Mail-Adresse.',
            },
            purchaser_age: 'Bestellperson Alter',
            stop: 'Haltestelle',
            options_info: 'Ausgewählte Zusatzoptionen sind nicht im Ticketpreis. Eventueller Zuschlag wird vom Fahrer vor der Fahrt abgezogen.',
            phone_length_error: 'Ungültige Länge der Telefonnummer',
            zip_length_error: 'Falsche Postleitzahllänge (mindestens 4 Zeichen)',
            email_validation: 'Ungültige E-Mail-Adresse',

            addresses: {
                ticket_type: 'Fahrkarte',
                ticket_types: {
                    normal: 'Normaltarif',
                    child: 'Kinder bis 4 Jahren alt',
                },
            },

            summary: {
                consents_text: 'Die Reservierung gilt als erfolgt, sobald die Zahlung erfolgt ist und die Bestätigung per E-Mail eingegangen ist. Sollte keine Bestätigung vorliegen, kontaktieren Sie uns bitte.',
            },
        },
        errors: {
            no_travels_found: 'Keine Fahrten zu den angegebenen Daten gefunden',
        },
    },

    tours: {
        header: 'Reisereservierung',
        date_from: 'Datum von',
        date_to: 'Datum bis',
        adults_count: 'Anzahl von Erwachsenen',
        person_count: 'Anzahl der Personen',
        children_count: 'Anzahl von Kindern',
        email: 'Ihre E-Mail-Adresse',
        message_content: 'Ihre Nachricht',
        name: 'Vor- und Nachname',
        phone: 'Telefonnummer',
        submit: 'Absenden',
        form_sent: 'Ihre Anfrage wurde verschickt',
    },

    berbus: {
        components: {
            search_form: {
                enter_address: 'Adresse angeben',
                search_no_results: 'Keine Ergebisse',
                flight_date: 'Abflug Datum',
                flight_time: 'Abflug/Ankunft Zeit',
            },

            cart: {
                passenger_types: {
                    adult: 'Erwachsene',
                    child_age_3: 'Kinder bis 3 Jahre',
                },
            },
            stopInfo: {
                title: 'Wo ist die BERBUS Haltestelle?',
                p1: 'BERBUS hält direkt vor dem Ausgang des Terminals T1 an den Glasüberdachungen auf der Ankunftsebene an.',
                p2: 'Genau hier wartet der BERBUS Minivan auf Reisende, die nach Stettin fahren möchten.',
            },
        },

        pages: {
            address: {
                header: 'Erforderliche Informationen',

                address_from: 'Adresse von',
                address_to: 'Adresse nach',

                go_back: 'Zurück',
                submit: 'Weiter zur Fahrtenauswahl',

                errors: {
                    invalid_search_param: 'Ungültiges Suchwort.',
                    invalid_passengers_adult: 'Ungültige Anzahl der Passagiere.',
                    no_addresses: 'Keine Adresse gefunden',
                    incomplete_start_address: 'Nicht ausgefüllte Felder für Adresse "von" ergänzen.',
                    incomplete_end_address: 'Nicht ausgefüllte Felder für Adresse "nach" ergänzen ',
                    start_zone_not_found: 'Keine Fahrten zu der angegebenen Adresse "von".',
                    end_zone_not_found: 'Keine Fahrten zu der angegebenen Adresse "nach".',
                    geo_response_error: 'Es ist ein Fehler bei der Adressensuche aufgetreten, versuchen Sie es später erneut.',
                },
            },

            vehicle: {
                price_per_person: '/ Person',
                description: 'Reisen Sie zu einem sehr guten Preis direkt von zu Hause aus! Eine Lösung basierend auf dem Prinzip des Ridesharings, bei dem wir Personen verbinden, die zur gleichen Zeit in die gleiche Richtung reisen. Nach der Zusammenführung aller Passagiere und einen Tag vor der Reise gibt Follow me! die endgültige Abholzeit von der angegebenen Adresse bekannt.',
            },

            passengers: {
                flight_time: 'Abflug/Ankunft Zeit',
                flight_time_from: 'Abfahrtszeit von',
                flight_time_to: 'Ankunftszeit bis',

                submit: 'Weiter zu Zusatzoptionen',
            },
        },
    },

    orders: {
        title: 'Meine Reservierungen',
        status: 'Status',
        departure_date: 'Hinfahrt Datum',
        route: 'Strecke',
        return_departure_date: 'Rückfahrt Datum',
        return_route: 'Rückfahrt Strecke',
        actions: 'Aktionen',
        details: 'Details',
        no_orders: 'Keine Reservierungen gefunden',
        consents: 'Zustimmungen',
        flight: 'Flug',
        components: {
            OrderStatusBadge: {
                created: 'In Bearbeitung',
                deferred_payment: 'Zahlung auf Rechnung',
                paid_auto: 'Bezahlt (Fahrzeug)',
                paid_manual: 'Bezahlt (manuell)',
                completed: 'Abgeschlossen',
                canceled_client: 'Abgesagt - vom Kunden storniert',
                canceled: 'Abgelehnt - Bestellfehler',
                payment_rejected: 'Abgelehnt - Zahlung',
                to_confirm: 'Reservierung muss bestätigt werden',
                canceled_fm: 'Abgesagt - keine Umsetzung Fm!',
                NOT_MERGED: 'Nicht zusammengeführt',
                MERGED: 'Zusammengeführt',
                PLANNED: 'Geplant',
                ACCEPTED: 'Akzeptiert',
                IN_PROGRESS: 'In Bearbeitung',
                COMPLETED: 'Abgeschlossen',
                CANCELLED: 'Storniert',
                CANCELLED_BY_CLIENT: 'Vom Kunden storniert',
                REQUEST_FOR_QUOTATION: 'Angebotsanfrage',
                CONFIRMATION: 'Bestätigung',
                REALIZATION: 'Realisierung',
                WAITING_FOR_PAYMENT: 'Warten auf Zahlung',
                REJECTED_NO_PAYMENT: 'Abgelehnt - keine Zahlung',
                HISTORICAL: 'Historisch',
            },
            PaymentStatusBadge: {
                pending: 'In Bearbeitung',
                paid: 'Bezahly',
                rejected: 'Abgelehnt',
                error: 'Fehler',
                MISSING: 'Fehlt',
                IN_PROGRESS: 'In Bearbeitung',
                PAID: 'Bezahlt',
                PARTIALLY_PAID: 'Teilweise bezahlt',
            },
        },
        bt: {
            title: 'Meine Reservierungen Business Taxi',
            my_orders: 'Meine Reservierungen BT',
        },
        fat: {
            title: 'Meine Reservierungen Smart Taxi',
            my_orders: 'Meine Reservierungen Smart Taxi',
        },
        berbus: {
            title: 'Meine Reservierungen BERBUS',
            my_orders: 'Meine Reservierungen BERBUS',
        },
        show: {
            title: 'Bestelldetails',
            return_to_list: 'Zurück zur Bestellliste',
            stops: 'Haltestellen',
            id: 'ID',
            order_details: 'Bestelldetails',
            start_place: 'Von',
            end_place: 'Nach',
            return_info: 'Rückfahrt Details',
            return_start_place: 'Rückfahrt von',
            return_end_place: 'Rückfahrt nach',
            no_return: 'Keine Rückfahrt',
            purchaser_info: 'Bestellperson Daten',
            purchaser_full_name: 'Vor- und Nachname',
            purchaser_email: 'E-Mail-Adresse',
            purchaser_phone: 'Telefonnummer',
            comment: 'Bemerkung',
            no_comment: 'Keine Bemerkung',
            order_values: 'Bestellung Wert',
            value_name: 'Wert',
            net_value: 'Wert netto',
            gross_value: 'Wert brutto',
            vat_value: 'VAT',
            base_value: 'Standardpreis (ohne Rabatt)',
            discount_value: 'Rabatt Wert',
            user_discount_value: 'Mitgliederrabatt Wert',
            value: 'Gesamtwert (inkl. Rabatt)',
            pln_value: 'Wert in PLN',
            payment_details: 'Zahlungsinformationen',
            return: 'Rückfahrt',
            invoice: {
                info: 'Rechnungsdaten',
                download_invoice: 'Rechnung herunterladen',
                company: 'Firmenname',
                vat_number: 'Steuernummer',
                email: 'E-Mail-Adresse',
                address: 'Adresse',
                zip: 'Postleitzahl',
                city: 'Stadt',
                country: 'Land',
            },
            payments: {
                status: 'Zahlungsstatus',
                provider: 'Zahlungssystemanbieter',
                amount: 'Wert',
                amount_pln: 'Wert [PLN]',
                no_payments_found: 'Keine registrierten Zahlungen',
            },
            passengers: {
                info: 'Fahrgäste Details',
                full_name: 'Vor- und Nachname',
                phone: 'Telefonnummer',
                no_passengers: 'Keine Fahrgäste',
            },
            additional_options: {
                info: 'Zusatzoptionen',
                name: 'Option',
                quantity: 'Anzahl',
            },
            travel_option: {
                cradle_0_13_kg: 'Wiege (0-13 kg)',
                child_seat_9_18_kg: 'Kindersitz (9-18 kg)',
                child_seat_15_25_kg: 'Kindersitz (15-25 kg)',
                booster_seat_22_36_kg: 'Kinderuntersitz (22-36 kg)',
                skiing_equipment: 'Skiausrüstung',
                bike: 'Fahrrad',
                stroller: 'Kinderwagen',
                musical_equipment: 'Musikgeräte',
                large_suitcase_15_32_kg: 'Großes Gepäck (15-32 kg)',
                no_travel_options: 'keine Zusatzoptionen',
            },
            payment_providers: {
                CASH: 'Bargeld',
                CARD: 'Karte',
                FAST_TRANSFER: 'Schnellüberweisung',
                TRADITIONAL_TRANSFER: 'Traditionelle Überweisung',
                ADVANCE: 'Vorauszahlung',
                CASH_DRIVER: 'Bargeld beim Fahrer',
                CARD_DRIVER: 'Karte beim Fahrer',
                TRANSFER: 'Überweisung',
            },
        },
    },

    coaches: {
        one_way: 'One-Way-Fahrt?',
        first_header: 'Füllen Sie das Formular aus und prüfen Sie unsere Preise.',
        second_header: 'Anfrage ist unverbindlich.',

        transfer_types: {
            pick_type: 'Fahrt Typ angeben',
            additional_options: 'Zusatzoptionen zeigen',
            types: {
                sport: 'Sportreise',
                school: 'Klassenfahrt',
                business: 'Firmenreise',
                tourist: 'Touristik Reise',
                event: 'Gelegentliche Reise',
                other: 'Andere',
                other_specify: 'Fahrt Typ beschreiben',
            },
        },
        additional_options: {
            title: 'Zusatzoptionen',
            child_seats: 'Kindersitze',
            sport_equipment: 'Sportausrüstung',
            music_equipment: 'Musikgeräte',
            notes: 'Bemerkungen',
            labels: {
                quantity: 'Anzahl',
                type: 'Typ',
            },
        },
        contact_data: {
            header: 'Kontaktdaten',

            name: 'Vor- und Nachname',
            company_name: 'Firmenname',
            address: 'Adresse',
            post_code: 'Postleitzahl',
            city: 'Stadt',
            country: 'Land',
            tax_number: 'Steuernummer',
            phone_number: 'Telefonnummer',
            email: 'E-Mail-Adresse',
            create_account: 'Benutzerkonto eröffnen',
            email_invalid: 'Gültige E-Mail-Adresse angeben',
        },
        summary: {
            basic_information: 'Standardinformationen',
            transfer_type: 'Fahrt Typ',
            additional_options: 'Zusatzoptionen',
            contact_data: 'Kontaktdaten',
            agreements: {
                header: 'Zustimmungen',

                rodo: 'DSGVO',
                marketing: 'Marketing',
                data_processing: 'Datenschutzverarbeitung',
                mailing: 'Per E-Mail geschickt',
            },
            order_created: 'Die Bestellung wurde korrekt registriert. Alle Informationen werden Ihnen in einer E-Mail zugesandt.',
            submit: 'Abschicken',
        },
    },

    btm: {
        basic_information: 'Standardinformationen',
        one_way: 'One-Way-Fahrt?',
        comment: 'Bemerkung',

        date_pick: 'Datum angeben',
        time_pick: 'Zeit angeben',

        from: 'Hinfahrt von',
        to: 'Ankunft in',

        travel_options: {
            base_options: 'Allgemeine Optionen',
            additional_options: 'Zusatzoptionen',
            header: 'Fahrt Typ',

            plane: {
                is_plane_ticket_needed: 'Ich brauche ein Flugticket',
                regular: 'Klassiche Linienflüge',
                low_cost: 'Low-Cost-Flüge',
                any: 'Wahlfrei',
            },
            transfer: {
                is_airport_transfer_needed: 'Ich brauche Flughafentransfer',
                bt: 'Business Taxi',
                at: 'Airport Shuttle',
                any: 'Wahlfrei',
            },
            hotel: {
                is_hotel_needed: 'Ich brauche Hotel',
                stars: 'Sterne',
                best_price: 'Bester Preis',
                best_quality: 'Beste Qualität',
            },
            insurance: {
                is_insurance_needed: 'Reiseversicherung',
            },
            ferry: {
                is_ferry_ticket_needed: 'Ich brauche Fähre-Ticket',
            },
            train: {
                is_train_ticket_needed: 'Ich brauche Bahnticket',
            },
            coach: {
                is_coach_ticket_needed: 'Ich brauche Busfahrkarte',
            },
            formal_assistance: {
                is_formal_assistance_needed: 'Ich brauche förmliche Hilfe (zB. Visum)',
            },
            event_assistance: {
                is_event_needed: 'Ich brauche Veranstaltung zu organisieren',
            },
        },

        fields: {
            plane_option: 'Flugticket',
            transfer_option: 'Flughafentransfer',
            hotel_stars: 'Hotel (Sterne)',
            hotel_preference: 'Bevorzugtes Hotel ',
            ferry_start_place: 'Fähre von',
            ferry_end_place: 'Fähre nach',
            train_start_place: 'Zug von',
            train_end_place: 'Zug nach',
            coach_start_place: 'Bus von',
            coach_end_place: 'Bus nach',
        },

        summary: {
            travel_options: 'Standardoptionen und Zusatzoptionen',
            order_created: 'Die Bestellung wurde korrekt registriert. Alle Informationen werden Ihnen in einer E-Mail zugesandt.',
            consents_text: '',
        },
    },

    consents: {
        'mark_all': 'Alle unten ankreuzen',
    },

    validation: {
        iam: {
            user: {
                email_not_unique: 'E-Mail-Adresse ist bereits registriert',
                login_is_invited: 'Das Konto ist inaktiv, aktivieren Sie Ihr Konto, indem Sie den Aktivierungscode aus der E-Mail-Nachricht eingeben',
                invalid_token_provided: 'Der angegebene Aktivierungscode ist ungültig',
                no_pending_invitation: 'Das Konto ist bereits aktiv oder wurde nicht registriert',
                not_found: 'Benutzer nicht gefunden',
            },
        },
        'at_least_one_passenger_required': 'Mindestens einen Fahrgast auswählen',
        'passwords_have_to_be_same': 'Felder Passwort und Passwort Bestätigung sind nicht identisch',
        'unable_to_login':
            'Die Anmeldung ist fehlgeschlagen. Überprüfen Sie Ihre E-Mail-Adresse und Ihr Passwort und versuchen Sie es erneut.',
        '4fbb52a8-6945-46b7-b103-a1f4b183082d':
            'Die Anmeldung ist fehlgeschlagen. Überprüfen Sie Ihre E-Mail-Adresse und Ihr Passwort und versuchen Sie es erneut.',
        '4b6f5c76-22b4-409d-af16-fbe823ba9332': 'Der Wert muss genau 6 Zeichen lang sein',
        orders: {
            client: {
                business_require_name: 'Das Feld Firmenname ist erforderlich',
                business_require_nip: 'Das Feld NIP ist erforderlich',
            },
            order: {
                invalid_ride_type: 'Ungültiger Fahrtentyp',
                ride_type_is_deactivated: 'Fahrtentyp ist deaktiviert',
                order_requires_min_one_passenger: 'Bestellung erfordert mindestens einen Passagier',
                order_requires_min_one_ride: 'Bestellung erfordert mindestens eine Fahrt',
                cyclic_start_must_be_earlier_than_end: 'Der zyklische Starttermin muss vor dem Endtermin liegen',
                no_available_rides_cyclic_found: 'Keine verfügbaren Fahrten im zyklischen Datumsbereich gefunden',
                order_cannot_be_created_in_short_time: 'Zu kurze Zeit bis zur Abfahrt – Buchung ist mindestens 48 Stunden vor Beginn der Fahrt möglich',
                order_requires_only_adult_passengers: 'Bestellung erfordert nur erwachsene Passagiere',
                order_requires_only_child_above_4_passengers: 'Bestellung erfordert nur Kinder über 4 Jahre',
                order_requires_ride_character: 'Fahrtentyp erfordert Charakter, aber Daten nicht angegeben',
                order_ride_stop_point_requires_date: 'Haltepunkt erfordert ein Datum',
                order_ride_requires_exactly_two_stops: 'Fahrt erfordert genau zwei Haltepunkte, aber ungültige Anzahl angegeben',
                order_ride_requires_at_least_two_stops: 'Fahrt erfordert mindestens zwei Haltepunkte, aber ungültige Anzahl angegeben',
                first_or_last_stop_point_must_have_date: 'Erster oder letzter Haltepunkt muss ein Datum haben',
                fmts_stop_points_dates_must_be_at_correct_time: 'Follow Me To School Fahrt hat Haltepunkte zu falschen Zeiten',
                order_ride_requires_flight_number: 'Fahrt erfordert Flugnummer, aber Daten nicht angegeben',
                order_ride_requires_flight_date: 'Fahrt erfordert Flugdatum, aber Daten nicht angegeben',
                order_ride_requires_vehicle_preferred: 'Fahrt erfordert bevorzugtes Fahrzeug, aber Daten nicht angegeben',
                order_ride_vehicle_preferred_not_exists: 'Angegebenes bevorzugtes Fahrzeug existiert nicht',
                additional_option_not_exists: 'Angegebene Zusatzoption existiert nicht',
                additional_option_not_active: 'Angegebene Zusatzoption ist nicht aktiv',
                voucher_not_exists: 'Angegebener Gutschein existiert nicht',
                voucher_is_not_available: 'Angegebener Gutschein ist nicht verfügbar',
                voucher_cannot_be_used: 'Angegebener Gutschein kann nicht verwendet werden',
                first_passenger_requires_personal_data: 'Persönliche Daten des ersten Passagiers nicht angegeben',
            },
            voucher: {
                voucher_not_exists: 'Der angegebene Gutschein existiert nicht',
                voucher_is_not_available: 'Der angegebene Gutschein ist nicht verfügbar',
                voucher_cannot_be_used: 'Der angegebene Gutschein kann nicht verwendet werden',
            },
        },
    },
};
